// constants/markdown.ts
var AllowedMarkdownElements = [
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "p",
  "span",
  "ul",
  "ol",
  "li",
  "strong",
  "em",
  "blockquote",
  "hr",
  "br",
  "a",
  "u",
  "img"
];

export { AllowedMarkdownElements };
